import { useProgramDependentDataContext } from '@/app/core/components/program-wizard/program-dependent-data-context';
import { ReactNode, Fragment } from 'react';
import { ClientAttributes } from '@ssar-app/domain';

interface OutputLocationsFetcherProps {
  subCode: string;
  onSuccess: (
    clientAttributes: ClientAttributes,
    isLoading: boolean,
  ) => ReactNode;
  onError: (error: Error) => void;
}

export const OutputLocationsFetcher = (props: OutputLocationsFetcherProps) => {
  const { onSuccess } = props;
  const { data } = useProgramDependentDataContext();

  return (
    <Fragment>
      {onSuccess(
        data && data?.clientAttributesModel
          ? data?.clientAttributesModel?.clientAttributes
          : {},
        false,
      )}
    </Fragment>
  );
};
